import React from 'react';
import ReactDOM from 'react-dom';
import './Styles/index.scss';
import App from './Containers/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register();

